import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { getPreviewPageUrl } from "../component/website/websitePageUrls";

/** Legacy React route — redirects to backend HTML so title/favicon/OG come from the page itself. */
export function PreviewWebsitePage() {
  const intl = useIntl();
  const { company, id } = useParams<{ company: string; id: string }>();

  useEffect(() => {
    if (!company || !id) return;
    try {
      const companyId = atob(company);
      window.location.replace(getPreviewPageUrl(companyId, id));
    } catch {
      window.location.replace("/");
    }
  }, [company, id]);

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div
        className="spinner-border text-primary"
        role="status"
        aria-label={intl.formatMessage({ id: "app.websitePage.preview.loading" })}
      />
    </div>
  );
}
